import React from 'react';

import { PERMISSION } from 'src/features/auth';

type User = {
    id: string;
    password: string;
    last_login: string | null;
    created_at: string;
    modified_at: string;
    name: string;
    username: string;
    email: string;
    is_active: boolean;
    is_staff: boolean;
    is_superuser: boolean;
    date_joined: string;
    roles: string[];
};

type AuthContextType = {
    user: User | null,
    permissions: PERMISSION[];
    permissionsLoaded: boolean;
};

const AuthContext = React.createContext<AuthContextType>({
    user: null,
    permissions: [],
    permissionsLoaded: true,
});

export default AuthContext;
